jQuery(document).ready(function ($) {
	if ($("body").hasClass("page-id-16")) {
		const DURATION = 2;

		animateVideo(".slider-marquee", "#blue-cta");

		function animateVideo(startElement, endElement) {
			const fadeIn = () => {
				gsap.to("#video_container video", {
					opacity: 1,
					duration: DURATION,
				});
			};

			const fadeOut = () => {
				gsap.to("#video_container video", {
					opacity: 0,
					duration: DURATION,
				});
			};

			gsap.to("#video_container video", {
				scrollTrigger: {
					trigger: startElement,
					start: "bottom center",
					end: "top bottom-=25%",
					endTrigger: endElement,
					onEnter: () => {
						fadeIn();
					},
					onEnterBack: () => {
						fadeIn();
					},
					onLeave: () => {
						fadeOut();
					},
					onLeaveBack: () => {
						fadeOut();
					},
				},
			});
		}
	}
});
